import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles<string>(({ breakpoints }: ITheme) => ({
  demoArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
  },
  uploaderSuggestion: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'var(--x-text-color-1)',
  },
  imageList: {
    padding: '0 24px',
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,

    [mediaQuery(breakpoints.tablet)]: {
      padding: '0 24px 0px 24px',
    },
  },
  suggestedImgContainer: {
    position: 'relative',
    width: 48,
    height: 48,
    cursor: 'pointer',
  },
  suggestedImgWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    '&:before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: 4,
      boxShadow: '0 0 0 2px #c209c1 inset',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      pointerEvents: 'none',
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out',
    },

    '&:hover': {
      '&:before': {
        opacity: 1,
      },
    },
  },
  suggestedImg: {
    '-webkit-user-drag': 'none',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    borderRadius: 4,
  },
}));

export default useStyles;
